import initialState from '../initialState.js';
import {
    GET_USER_SUCCESS,
    GET_USERS_SUCCESS,
    UPDATE_USER_SUCCESS,
    TERMINATE_USER_SUCCESS,
    GET_USER_CLAIM_SUCCESS,
    CLEAR_SELECTED_CLAIM,
    ADD_DEPENDENT_SUCCESS,
    UPDATE_DEPENDENT_SUCCESS,
    REMOVE_DEPENDENT_SUCCESS,
    ADD_BENEFICIARY_SUCCESS,
    UPDATE_BENEFICIARY_SUCCESS,
    REMOVE_BENEFICIARY_SUCCESS,
    UPDATE_CURRENT_BENEFICIARIES,
    ADD_TRUSTEE_SUCCESS,
    UPDATE_TRUSTEE_SUCCESS,
    REMOVE_TRUSTEE_SUCCESS,
    REMOVE_NOTIFICATION_SUCCESS,
    ADD_MEMBER_NOTE,
    GET_MEMBER_NOTES,
    UPDATE_CLAIM,
    GET_CLAIMS_SUCCESS,
    GET_HSA_CLAIMS_SUCCESS,
    GET_LSA_CLAIMS_SUCCESS,
    UPDATE_HSA_CLAIMS,
    UPDATE_LSA_CLAIMS,
    UPDATE_USER_BENEFIT_PREMIUMS,
    UPDATE_USER_BENEFIT_STATUS
} from '../../actions/types/users';

export default (state = initialState.users, action) => {
    switch (action.type) {
        case GET_USER_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...action.currentUser,
                    claimsCursor: 10
                }
            };
        }

        case ADD_MEMBER_NOTE: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    notes: [ action.data, ...state.currentUser.notes ]
                }
            };
        }

        case UPDATE_CLAIM: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    claims: state.currentUser.claims.map((claim) => {
                        if (claim.claimID === action.claimID) {
                            return {
                                ...claim,
                                ...action.data
                            };
                        }

                        return claim;
                    })
                }
            };
        }

        case GET_CLAIMS_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    claims: action.shouldAppend ? [ ...state.currentUser.claims, ...action.claims ] : action.claims,
                    claimsCursor: action.cursor
                }
            };
        }

        case GET_HSA_CLAIMS_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    spending: {
                        ...state.currentUser.spending,
                        health: {
                            ...state.currentUser.spending.health,
                            items: action.claims
                        }
                    }
                }
            };
        }

        case GET_LSA_CLAIMS_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    spending: {
                        ...state.currentUser.spending,
                        lifestyle: {
                            ...state.currentUser.spending.lifestyle,
                            items: action.claims
                        }
                    }
                }
            };
        }

        case UPDATE_HSA_CLAIMS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser, 
                    spending: { 
                        ...state.currentUser.spending,
                        health: {
                            ...state.currentUser.spending.health,
                            items: state.currentUser.spending.health.items.map((claim) => {
                                if (claim.claimID === action.claimID) {
                                    return {
                                        ...claim,
                                        ...action.data
                                    };
                                }

                                return claim;
                            })
                        }
                    }
                }
            };
        }

        case UPDATE_LSA_CLAIMS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser, 
                    spending: { 
                        ...state.currentUser.spending,
                        lifestyle: {
                            ...state.currentUser.spending.lifestyle,
                            items: state.currentUser.spending.lifestyle.items.map((claim) => {
                                if (claim.claimID === action.claimID) {
                                    return {
                                        ...claim,
                                        ...action.data
                                    };
                                }

                                return claim;
                            })
                        }
                    }
                }
            };
        }

        case GET_MEMBER_NOTES: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    notes: action.notes
                }
            };
        }

        case GET_USERS_SUCCESS: {
            const users = state.list ? [ ...state.list ] : [];

            return {
                ...state,
                list: action.shouldAppend ? [ ...users, ...action.users ] : [ ...action.users ],
                cursor: action.cursor
            };
        }

        case GET_USER_CLAIM_SUCCESS: {
            return {
                ...state,
                claimDetails: action.claimDetails
            };
        }

        case UPDATE_USER_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    meta: {
                        ...state.currentUser.meta,
                        ...action.body
                    }
                }
            };
        }

        case TERMINATE_USER_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    meta: {
                        ...state.currentUser.meta,
                        status: 9
                    }
                }
            };
        }

        case CLEAR_SELECTED_CLAIM: {
            return {
                ...state,
                claimDetails: null
            };
        }

        case ADD_DEPENDENT_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    dependents: [ action.dependent, ...state.currentUser.dependents ],
                    meta: {
                        ...state.currentUser.meta,
                        coverageThroughSpouse: action.spouseCoverage
                    }
                }
            };
        }

        case UPDATE_DEPENDENT_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    dependents:
                        state.currentUser.dependents.map((dependent) => {
                            if (dependent.dependentID === action.dependentID) {
                                return {
                                    ...dependent,
                                    ...action.dependent
                                };
                            }

                            return dependent;
                        }),
                    meta: {
                        ...state.currentUser.meta,
                        coverageThroughSpouse: action.spouseCoverage
                    }
                }
            };
        }

        case REMOVE_DEPENDENT_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    dependents:
                        state.currentUser.dependents.filter((dependent) => dependent.dependentID !== action.dependentID)
                }
            };
        }

        case ADD_BENEFICIARY_SUCCESS: {

            if (action.isContingent) {
                return {
                    ...state,
                    currentUser: {
                        ...state.currentUser,
                        beneficiaries: {
                            primary: [ ...state.currentUser.beneficiaries.primary ],
                            contingent: [ action.beneficiary, ...state.currentUser.beneficiaries.contingent ]
                        }
                    }
                };
            }

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    beneficiaries: {
                        contingent: [ ...state.currentUser.beneficiaries.contingent ],
                        primary: [ action.beneficiary, ...state.currentUser.beneficiaries.primary ]
                    }
                }
            };
        }

        case UPDATE_BENEFICIARY_SUCCESS: {
            if (action.isContingent) {
                return {
                    ...state,
                    currentUser: {
                        ...state.currentUser,
                        beneficiaries: {
                            contingent: state.currentUser.beneficiaries.contingent.map((beneficiary) => {
                                if (beneficiary.beneficiaryID === action.beneficiaryID) {
                                    return {
                                        ...beneficiary,
                                        ...action.beneficiary
                                    };
                                }

                                return beneficiary;
                            }),
                            primary: [ ...state.currentUser.beneficiaries.primary ]
                        }
                    }
                };
            }

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    beneficiaries: {
                        primary: state.currentUser.beneficiaries.primary.map((beneficiary) => {
                            if (beneficiary.beneficiaryID === action.beneficiaryID) {
                                return {
                                    ...beneficiary,
                                    ...action.beneficiary
                                };
                            }

                            return beneficiary;

                        }),
                        contingent: [ ...state.currentUser.beneficiaries.contingent ]
                    }
                }
            };
        }

        case REMOVE_BENEFICIARY_SUCCESS: {
            if (action.isContingent) {
                return {
                    ...state,
                    currentUser: {
                        ...state.currentUser,
                        beneficiaries: {
                            contingent: state.currentUser.beneficiaries.contingent.filter((beneficiary) => beneficiary.beneficiaryID !== action.beneficiaryID),
                            primary: [ ...state.currentUser.beneficiaries.primary ]
                        }
                    }
                };
            }

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    beneficiaries: {
                        primary: state.currentUser.beneficiaries.primary.filter((beneficiary) => beneficiary.beneficiaryID !== action.beneficiaryID),
                        contingent: [ ...state.currentUser.beneficiaries.contingent ]
                    }
                }
            };
        }

        case UPDATE_CURRENT_BENEFICIARIES: {
            if (action.isContingent) {
                const currentBeneficiaries = action.currentBeneficiaries.contingent;
                return {
                    ...state,
                    currentUser: {
                        ...state.currentUser,
                        beneficiaries: {
                            contingent: state.currentUser.beneficiaries.contingent.map((beneficiary) => {
                                currentBeneficiaries.some((currentBeneficiary) => {
                                    if (currentBeneficiary.beneficiaryID === beneficiary.beneficiaryID) {
                                        beneficiary = {
                                            ...beneficiary,
                                            ...currentBeneficiary
                                        };

                                        return true;
                                    }

                                    return false;
                                });

                                return {
                                    ...beneficiary
                                };
                            }),
                            primary: [ ...state.currentUser.beneficiaries.primary ]
                        }
                    }
                };
            }

            const currentBeneficiaries = action.currentBeneficiaries.primary;
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    beneficiaries: {
                        primary: state.currentUser.beneficiaries.primary.map((beneficiary) => {
                            currentBeneficiaries.some((currentBeneficiary) => {
                                if (currentBeneficiary.beneficiaryID === beneficiary.beneficiaryID) {
                                    beneficiary = {
                                        ...beneficiary,
                                        ...currentBeneficiary
                                    };

                                    return true;
                                }

                                return false;
                            });

                            return {
                                ...beneficiary
                            };
                        }),
                        contingent: [ ...state.currentUser.beneficiaries.contingent ]
                    }
                }
            };
        }

        case ADD_TRUSTEE_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    trustee: action.trustee
                }
            };
        }

        case UPDATE_TRUSTEE_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    trustee: { ...state.currentUser.trustee, ...action.trustee }
                }
            };
        }

        case REMOVE_TRUSTEE_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    trustee: action.trustee
                }
            };
        }

        case REMOVE_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    notifications: state.currentUser.notifications.filter((item) => item.id !== action.id)
                }
            };
        }

        case UPDATE_USER_BENEFIT_PREMIUMS: {
            const updatedCoverage = { ...state.currentUser.coverage };

            // This handles 1 benefit or 15 benefits the exact same way
            (action.data || []).forEach((item) => {
                const { benefitName, ...data } = item;
                if (updatedCoverage[benefitName]) {
                    updatedCoverage[benefitName] = {
                        ...updatedCoverage[benefitName],
                        ...data
                    };
                }
            });

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    coverage: updatedCoverage
                }
            };
        }

        case UPDATE_USER_BENEFIT_STATUS: {
            const { benefitName, ...updatedData } = action.data;
            const currentBenefit = state.currentUser.coverage[benefitName];

            // If it's spendingAccounts, nesting updatedData inside 'meta'
            const updatedBenefitValue = benefitName === 'spendingAccounts'
                ? {
                    ...currentBenefit,
                    meta: {
                        ...currentBenefit.meta,
                        ...updatedData
                    }
                }
                : {
                    ...currentBenefit,
                    ...updatedData
                };

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    coverage: {
                        ...state.currentUser.coverage,
                        [benefitName]: updatedBenefitValue
                    }
                }
            };
        }

        default:
            return state;
    }
};